import './styles.scoped.css';
export default {
  "root": "awsui_root_1i0s3_19emo_93",
  "header": "awsui_header_1i0s3_19emo_104",
  "content": "awsui_content_1i0s3_19emo_108",
  "error": "awsui_error_1i0s3_19emo_112",
  "footer": "awsui_footer_1i0s3_19emo_116",
  "actions-section": "awsui_actions-section_1i0s3_19emo_120",
  "secondary-actions": "awsui_secondary-actions_1i0s3_19emo_129",
  "actions": "awsui_actions_1i0s3_19emo_120"
};